/* eslint-disable import/first, import/newline-after-import */

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import AbDetectionController from 'components/analytics/ab-detection-controller';
EezyStimulusApplication.register('ab-detection', AbDetectionController);

import GoogleTagManagerController from 'components/analytics/google-tag-manager/google-tag-manager-controller';
EezyStimulusApplication.register('google-tag-manager', GoogleTagManagerController);

/* EventTrackerController is Deprecated */
import EventTrackerController from 'components/analytics/conversions/event-tracker-controller';
EezyStimulusApplication.register('event-tracker', EventTrackerController);

/* Please use TrackTriggerEvent, TrackEvent, and TrackCompleteEvent controllers */
import TrackTriggerEventController from 'components/analytics/conversions/track-trigger-event-controller';
EezyStimulusApplication.register('track-trigger-event', TrackTriggerEventController);

import TrackEventController from 'components/analytics/conversions/track-event-controller';
EezyStimulusApplication.register('track-event', TrackEventController);

import TrackCompleteEventController from 'components/analytics/conversions/track-complete-event-controller';
EezyStimulusApplication.register('track-complete-event', TrackCompleteEventController);

import FormAnalyticsController from 'components/analytics/conversions/form-analytics-controller';
EezyStimulusApplication.register('form-analytics', FormAnalyticsController);

import ClickTrackController from 'controllers/click-track-controller';
EezyStimulusApplication.register('click-track', ClickTrackController);

import SearchAnalyticsController from 'components/analytics/search/search-analytics-controller';
EezyStimulusApplication.register('search-analytics', SearchAnalyticsController);
